import axios from 'axios';
import config from '../config';
import { Device, OnboardDevicesQueryParams, OnboardDevicesResponse } from '../interfaces';

export const DEFAULT_ONBOARD_DEVICES_PAGE_SIZE = 25;

export const getOnboardDevices = (
    params: OnboardDevicesQueryParams,
    signal?: AbortSignal,
): Promise<OnboardDevicesResponse> => {
    const { filters, ...queryParams } = params;

    return axios
        .get(`${config.API_URL}/onboard-devices`, {
            params: {
                ...queryParams,
                filters: filters && filters.length > 0 ? JSON.stringify(filters) : undefined,
            },
            signal,
        })
        .then((response: any) => {
            const data = response.data.data;
            const fallbackItems = (data.devices || []) as Device[];
            const items = (data.items || fallbackItems) as Device[];

            return {
                items,
                pagination: data.pagination || {
                    page: params.page,
                    pageSize: params.pageSize,
                    totalItems: fallbackItems.length,
                    totalPages: Math.ceil(fallbackItems.length / params.pageSize),
                    hasNextPage: false,
                    hasPreviousPage: params.page > 1,
                },
            };
        });
};
